export class MathHelper {
  public static roundTo(num: number, precision: number) {
    const multi = Math.pow(10, precision);
    const rounded_num = Math.round(num * multi) / multi;

    return rounded_num.toFixed(precision);
  }

  /** Like roundTo, but returns a number instead of a fixed-precision string. */
  public static roundToNumber(num: number, precision: number): number {
    const multi = Math.pow(10, precision);
    return Math.round(num * multi) / multi;
  }

  public static isFloat(num: any): boolean {
    return typeof num === "number" && !Number.isInteger(num);
  }

  public static formatToMaxOneDecimal(num: number): string {
    const rounded = Math.round(num * 10) / 10;
    return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  }

  /** Round to at most 3 decimal places (kW precision), dropping trailing zeros. */
  public static formatMw(num: number): string {
    return parseFloat(num.toFixed(3)).toString();
  }
}
